var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement-content-wrapper flex flex-col"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("page.useAgreement")))]),_c(_vm.use,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }